import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "@shop-ledger/ui-components/styles.css";
import "./index.css";
import { App } from "./App";

// Ported from pos-pwa/src/main.tsx as part of that app's merge into this one — §13 rule 3:
// the service worker must implement a rigid client-side fallback for the app shell so a
// reload of `/pos/till` while offline still works. `immediate: true` activates a new SW as
// soon as it's installed rather than waiting for every open tab to close.
registerSW({ immediate: true });

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("#root element not found");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
